import { Row } from "antd";
import DeferredImage from "../deferred-image/deferred-image";
import "./map-section.css";
import map from "./static/map.webp";
import AppTitle from "../app-title/app-title";

function MapSection({ showTitle = true }) {
  return (
    <>
      {showTitle && <AppTitle text={"Наши центры"} />}
      <Row className="map">
        <div className="shadow_for_map_top"></div>
        <DeferredImage
          width={1920}
          height={681}
          src={map}
          alt="Карта сервисных центров General Trucks"
          loading="lazy"
        />
        <div className="shadow_for_map_bot"></div>
      </Row>
    </>
  );
}

export default MapSection;
